"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Header;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
const useStyles = (0, _styles.makeStyles)(theme => (0, _styles.createStyles)({
  container: {
    backgroundColor: _episourceColor["default"].epiAnalystBackgroundLight,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 3),
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)'
  },
  logo: {
    'paddingLeft': theme.spacing(3),
    'display': 'inline-block',
    '& > img': {
      height: '39px'
    }
  },
  logoGrouping: {
    display: 'flex',
    alignItems: 'center'
  }
}));
function Header(_ref) {
  let {
    imageLogo,
    navBar,
    rightArea,
    leftArea
  } = _ref;
  const classes = useStyles({});
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.logoGrouping
  }, leftArea, /*#__PURE__*/_react["default"].createElement("a", {
    href: "/",
    title: "Home",
    className: classes.logo
  }, imageLogo)), navBar, rightArea);
}
Header.defaultProps = {
  rightArea: null,
  leftArea: null
};